import { render, staticRenderFns } from "./AddPointsChooseGroupLocation.vue?vue&type=template&id=1890fb7f&scoped=true&"
import script from "./AddPointsChooseGroupLocation.vue?vue&type=script&lang=js&"
export * from "./AddPointsChooseGroupLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1890fb7f",
  null
  
)

export default component.exports